// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rneWCz5kmIcHoEN9mr7x{cursor:pointer;border-radius:6px;align-items:center;padding:4px 4px 4px 6px;display:flex}.rneWCz5kmIcHoEN9mr7x:hover{background:var(--gray-10)}.QGjFHIKi7EY6S2Rm63hV{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownTriggerComponent": `rneWCz5kmIcHoEN9mr7x`,
	"headerName": `QGjFHIKi7EY6S2Rm63hV`
};
export default ___CSS_LOADER_EXPORT___;
